/* eslint-disable no-bitwise */
import Licenses from '../licensing/Licenses';

interface AuthenticatedUser {
  firstName: string;
  lastName: string;
  email: string;
  id: number;
  permissions: string[];
  otherPrivileges: string[];
  license?: number | undefined;
  effectiveLicense?: number | undefined;
  isAdmin: boolean;
  isApprover: boolean;
}

const _isReadOnlyLicense = (license: number) => (license & Licenses.ReadOnlyProfessional) === Licenses.ReadOnlyProfessional;

const _hasNonReadOnlyLicense = (license: number) => {
  if ((license & Licenses.TimeProfessional) === Licenses.TimeProfessional
    || (license & Licenses.TimeEnterprise) === Licenses.TimeEnterprise
    || (license & Licenses.TotalETOProfessional) === Licenses.TotalETOProfessional
    || (license & Licenses.TotalETOEnterprise) === Licenses.TotalETOEnterprise) {
    return true;
  }
  return false;
};

export const hasPermission = (user: AuthenticatedUser, permission: string) => {
  if (user.license === 0) { return false; }

  if (_hasNonReadOnlyLicense(user.license ?? 0)) {
    return user.permissions && user.permissions.indexOf(permission) >= 0;
  }

  if (_isReadOnlyLicense(user.license ?? 0)) {
    if (permission.endsWith('Timecards') || permission.endsWith('Punchcards')) { return true; }
    if (!permission.startsWith('View--')) { return false; }
  }

  return user.permissions && user.permissions.indexOf(permission) >= 0;
};

export const hasAnyPermission = (user: AuthenticatedUser, permissions: string[]) => {
  for (let i = 0; i < permissions.length; i += 1) {
    if (hasPermission(user, permissions[i])) { return true; }
  }
  return false;
};

export const hasAllPermissions = (user: AuthenticatedUser, permissions: string[]) => {
  for (let i = 0; i < permissions.length; i += 1) {
    if (!hasPermission(user, permissions[i])) { return false; }
  }
  return true;
};

export const hasOtherPrivilege = (user: AuthenticatedUser, otherPrivilege: string) => {
  if (user.license === 0) { return false; }
  return user.otherPrivileges && user.otherPrivileges.indexOf(otherPrivilege) >= 0;
};

export const hasAnyOtherPrivilege = (user: AuthenticatedUser, otherPrivileges: string[]) => {
  for (let i = 0; i < otherPrivileges.length; i += 1) {
    if (hasOtherPrivilege(user, otherPrivileges[i])) { return true; }
  }
  return false;
};

export const hasAllOtherPrivileges = (user: AuthenticatedUser, otherPrivileges: string[]) => {
  for (let i = 0; i < otherPrivileges.length; i += 1) {
    if (!hasOtherPrivilege(user, otherPrivileges[i])) { return false; }
  }
  return true;
};

export default AuthenticatedUser;
